import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import API_BASE_URL from "../API/ConfigAPI";

function useLogin() {
  const navigate = useNavigate();

  const fetchUserDetails = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_BASE_URL}/home/api/users/${userId}/`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Erreur lors de la récupération de l'utilisateur");
      }

      const data = await response.json();
      localStorage.setItem("is_admin", JSON.stringify(data.is_admin));
      localStorage.setItem("username", data.username);
      localStorage.setItem("userId", data.id);
      localStorage.setItem("first_name", data.first_name);

      navigate(data.is_admin ? "/users" : "/facturation");
    } catch (error) {
      console.error("Erreur récupération utilisateur:", error);
      toast.error("Erreur lors de la récupération de votre compte.");
    }
  };

  const login = async (username, password, setErrorMessage) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        localStorage.setItem("token", data.token);
        await fetchUserDetails(data.user_id);
        toast.success("Connexion réussie !");
      } else {
        setErrorMessage("Identifiants invalides.");
        toast.error("Identifiants invalides.");
      }
    } catch (error) {
      console.error("Erreur de connexion:", error);
      setErrorMessage("Erreur lors de la tentative de connexion.");
      toast.error("Erreur lors de la tentative de connexion.");
    }
  };

  return { login };
}

export default useLogin;
